export default __webpack_public_path__ + "static/media/dash-16.208fcb48.svg";